import type { ConceptDef } from '../types';

export const matchColors: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-colors',
  label: 'Match Colors',
  category: 'Matching',
  description: 'See a color swatch; tap the same color among labeled tiles.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '🟥', answer: '🟥 red' },
      { say: '🟦', answer: '🟦 blue' },
      { say: '🟩', answer: '🟩 green' },
      { say: '🟨', answer: '🟨 yellow' },
      { say: '🟪', answer: '🟪 purple' },
      { say: '🟧', answer: '🟧 orange' },
    ],
  },
};
